import React from 'react';
import slugify from 'slugify';
import { Link } from 'react-router-dom';

const dateBr = (publicated_at) => {
  const dt = publicated_at.substring(0, 10).split('-');
  return `${dt[2]}/${dt[1]}/${dt[0]}`;
};

const buildLink = (newspaper, linkToEdition) => {
  const slugName = slugify(newspaper.name, {
    replacement: '-',
    remove: null,
    lower: true,
  });
  if (linkToEdition) return `/jornal/${newspaper.id}/${slugName}/${newspaper.edition.id}`;
  return `/jornal/${newspaper.id}/${slugName}`;
};

export default props => (
  <div className="box-newspaper text-center">
    <Link to={buildLink(props.newspaper, props.linkToEdition)}>
      <div>
        <img
          className="img-fluid"
          src={props.newspaper.edition.images.original}
          alt={props.newspaper.name}
          title={props.newspaper.name}
        />
      </div>
      {!props.noTitle && <h2 className="text-center">{props.newspaper.name}</h2>}
    </Link>
    {!props.noDate && (
      <span className="publicated-at">{dateBr(props.newspaper.edition.publicated_at)}</span>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Newspaper/index.js